export const VENDOR_IDS = {
  AG1: '66b544344474800031e1f2b3',
};
